import { JetView } from 'webix-jet';
import { profile, devConfig, countries, paymentSystem, cashDesks, agentList } from 'config/config';

/**
 * Class representing the FilterDepositReportsView.
 * @extends JetView
 */
export default class FilterDepositReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'),
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(),
                                },
                            },
                        },
                        {
                            hidden: devConfig.getPermAction('filterByUser', 'Add'),
                            css: 'prm-filterByUser',
                            height: 1,
                        },
                        {
                            view: 'text',
                            name: 'PlayerId',
                            type: 'number',
                            label: "<span class='icon-user'></span>" + _('ID Usuario'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                            invalidMessage: _('ID Usuario is required'),
                        },
                        {
                            view: 'text',
                            name: 'FinalId',
                            type: 'number',
                            label: "<span class='icon-user'></span>" + _('ID Final'),
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Final'),
                            invalidMessage: _('ID Final is required'),
                        },
                        {
                            hidden: devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                            height: 1,
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries,
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect2',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry,
                            readonly: true,
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries,
                                },
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry country-hide',
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'combo',
                            name: 'PaymentSystemId',
                            label: "<span class='icon-credit-card'></span>" + _('Tipo Pasarela de Pago'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            id: 'PaymentSystemId',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json',
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'es/Select/PaymentSystemsSelect',
                                                '{"Filter":"' + text + '"}',
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message('Error! ');
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var resp = JSON.parse(text);
                                                        if (!resp.HasError) {
                                                            vthis.parse(resp.Data);
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo',
                            name: 'CashDeskId',
                            label: _('Recepción de Efectivo'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            id: 'CashDeskId',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/BetShopsSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo',
                            name: 'AgentList',
                            label: "<span class='icon-user-secret'></span>" + _('Agente'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            id: 'AgentList',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/AgentListSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data);
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'text',
                            name: 'Ip',
                            label: "<span class='icon-ip'></span>" + _('Direccion IP'),
                            labelPosition: 'top',
                            placeholder: _('Direccion IP '),
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            label: "<span class='icon-id'></span>" + _('ID'),
                            labelPosition: 'top',
                            placeholder: _('ID'),
                        },
                        {
                            view: 'text',
                            name: 'ExternalId',
                            label: "<span class='icon-id'></span>" + _('External ID'),
                            labelPosition: 'top',
                            placeholder: _('External ID'),
                        },
                        {
                            view: 'daterangepicker',
                            name: 'ModifiedLocal',
                            id: 'ModifiedLocal',
                            stringResult: true,
                            minWidth: 350,
                            timepicker: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Modificado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            format: '%Y-%m-%d %h:%i %a',
                        },
                        {
                            view: 'richselect',
                            name: 'State',
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'A', value: _('Pagada') },
                                { id: 'E', value: _('Enviada') },
                                { id: 'R', value: _('Rechazada') },
                            ],
                        },
                    ],
                },
                { id: 'grav2', cols: [], height: 50 },
            ],
        };
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 580 : 0,
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    minWidth: 200,
                    view: 'button',
                    value: _('Contracargos'), // Button label for "Contracargos" (Chargebacks)
                    type: 'form',
                    width: screen == 'small' ? 0 : 150, // Adjusts width based on screen size
                    hidden: !devConfig.getPermAction('chargeBacks', 'Add'), // Visibility based on permissions
                    css: 'prm-chargeBacks', // CSS class for styling
                    /**
                     * Click event handler for the "Contracargos" button.
                     * Opens a modal window for managing chargebacks.
                     */
                    click: () => {
                        /**
                         * Converts a file to Base64 format.
                         * @param {File} file - The file to convert.
                         * @returns {Promise<string>} A promise that resolves with the Base64 string.
                         */
                        function getBase64(file) {
                            return new Promise((resolve, reject) => {
                                const reader = new FileReader();
                                reader.readAsDataURL(file);
                                reader.onload = () => resolve(reader.result);
                                reader.onerror = (error) => reject(error);
                            });
                        }

                        // Create and display the chargebacks modal window
                        webix.ui({
                            view: 'window',
                            id: 'ChargeBacks', // Unique ID for the window
                            fullscreen: screen.width < 500 ? true : false, // Fullscreen for small screens
                            width: screen.width < 500 ? null : 500, // Fixed width for larger screens
                            head: {
                                view: 'toolbar',
                                cols: [
                                    { view: 'label', label: _('Contracargos') }, // Window title
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close', // Close icon
                                        click: function () {
                                            this.getTopParentView().hide(); // Close the window
                                        },
                                    },
                                ],
                            },
                            position: 'center', // Center the window
                            modal: true, // Enable modal behavior
                            body: {
                                view: 'form',
                                id: 'chargeBacksForm', // Form ID
                                elements: [
                                    {
                                        rows: [
                                            {
                                                view: "fieldset",
                                                label: "Ingresar ID único", // Fieldset label
                                                body: {
                                                    cols: [
                                                        {
                                                            view: "text",
                                                            label: _("EXTERNAL ID DEL DEPÓSITO:"), // Input label
                                                            name: "ExternalId",
                                                            id: "ExternalId", // Input ID
                                                            labelWidth: 220, // Label width
                                                            required: true, // Mark as required
                                                            fillspace: true,
                                                            attributes: { type: "text", min: 0 } // Input attributes
                                                        },
                                                        {
                                                            view: "button",
                                                            value: _("Guardar"), // Button label
                                                            width: 120,
                                                            css: "webix_primary", // Primary button styling
                                                            /**
                                                             * Click event handler for saving the External ID.
                                                             * Sends the ID to the server via an AJAX request.
                                                             */
                                                            click: function () {
                                                                let externalId = $$("ExternalId").getValue();

                                                                if (!externalId) {
                                                                    webix.message("Por favor ingresa un EXTERNAL ID");
                                                                    return;
                                                                }

                                                                webix.ajax()
                                                                    .headers({
                                                                        "Content-type": "application/json",
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() + "Report/ReportChargesDeposits",
                                                                        JSON.stringify({
                                                                            ExternalId: externalId,
                                                                            ExternalIdCsv: ""
                                                                        }),
                                                                        {
                                                                            error: function () {
                                                                                webix.message("Error al procesar la solicitud");
                                                                                $$("ExternalId").define("required", false);
                                                                                $$("ExternalId").setValue("");
                                                                                $$("ExternalId").clearValidation();
                                                                                $$("ExternalId").define("required", true);
                                                                            },
                                                                            success: function (text) {
                                                                                text = JSON.parse(text);
                                                                                if (!text.HasError) {
                                                                                    webix.message(text.AlertMessage);
                                                                                }
                                                                                $$("ExternalId").define("required", false);
                                                                                $$("ExternalId").setValue("");
                                                                                $$("ExternalId").clearValidation();
                                                                                $$("ExternalId").define("required", true);
                                                                            },
                                                                        }
                                                                    );
                                                            },
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                template: "<div style='text-align:center; font-weight:bold; margin:10px 0;'>OR</div>", // Separator template
                                                borderless: true,
                                                autoheight: true
                                            },
                                            {
                                                view: "fieldset",
                                                label: "Subir archivo CSV con multiples ID", // Fieldset label
                                                body: {
                                                    view: "uploader",
                                                    id: "ExternalIdCsv", // Uploader ID
                                                    value: _("Cargar archivo CSV"), // Button label
                                                    autosend: false, // Disable auto-upload
                                                    /**
                                                     * Event handler for file upload.
                                                     * Converts the file to Base64 and sends it to the server.
                                                     */
                                                    on: {
                                                        onBeforeFileAdd: function (upload) {
                                                            getBase64(upload.file).then((data) => {
                                                                let base64CSV2 = data;
                                                                $$("ExternalId").disable();

                                                                if (base64CSV2) {
                                                                    webix.ajax()
                                                                        .headers({ "Content-type": "application/json" })
                                                                        .post(
                                                                            devConfig.geturlApi() + "Report/ReportChargesDeposits",
                                                                            JSON.stringify({ ExternalId: "", ExternalIdCsv: base64CSV2 }),
                                                                            {
                                                                                error: function () {
                                                                                    webix.message("Error al procesar el archivo");
                                                                                    $$("ExternalId").enable();
                                                                                },
                                                                                success: function (text) {
                                                                                    $$("ExternalId").enable();
                                                                                    text = JSON.parse(text);
                                                                                    if (!text.HasError) {
                                                                                        webix.message(text.AlertMessage);
                                                                                    }
                                                                                }
                                                                            }
                                                                        );
                                                                } else {
                                                                    $$("ExternalId").enable();
                                                                }
                                                            });
                                                            return false; // Prevent default upload behavior
                                                        }
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                ],
                                elementsConfig: {
                                    on: {
                                        onChange: function () {
                                            this.validate(); // Validate form on change
                                        },
                                    },
                                },
                            },
                        }).show(); // Display the modal window
                    },
                },
                {
                    minWidth: 200,
                    view: 'button',
                    value: _('Aprobación Masiva'),
                    type: 'form',
                    width: screen == 'small' ? 0 : 250,
                    hidden: !devConfig.getPermAction('depositMassive', 'Add'),
                    css: 'prm-depositMassive',
                    click: () => {
                        /**
                         * Converts a file to Base64 format.
                         * @param {File} file - The file to convert.
                         * @returns {Promise} A promise that resolves with the Base64 string.
                         */
                        function getBase64(file) {
                            return new Promise((resolve, reject) => {
                                const reader = new FileReader();
                                reader.readAsDataURL(file);
                                reader.onload = () => resolve(reader.result);
                                reader.onerror = (error) => reject(error);
                            });
                        }
                        var base64CSV2 = '';
                        webix
                            .ui({
                                view: 'window',
                                id: 'DepositMassive',
                                fullscreen: screen.width < 500 ? true : false,
                                head: {
                                    view: 'toolbar',
                                    cols: [
                                        {
                                            view: 'label',
                                            label: _('Aprobar Depósitos Masivos'),
                                        },
                                        {
                                            view: 'icon',
                                            icon: 'wxi-close',
                                            click: function () {
                                                this.getTopParentView().hide();
                                            },
                                        },
                                    ],
                                },
                                position: 'center',
                                modal: true,
                                body: {
                                    view: 'form',
                                    id: 'depositMassiveForm',
                                    elements: [
                                        {
                                            margin: 10,
                                            rows: [
                                                {
                                                    view: 'uploader',
                                                    id: 'uploader4',
                                                    value: _('Cargar archivo CSV'),
                                                    on: {
                                                        onBeforeFileAdd: function (upload) {
                                                            getBase64(upload.file).then((data) => (base64CSV2 = data));
                                                            $$('uploader4').define('label', upload.name);
                                                            $$('uploader4').refresh();
                                                        },
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            cols: [
                                                {
                                                    view: 'button',
                                                    value: _('Cancelar'),
                                                    click: function () {
                                                        this.getTopParentView().hide();
                                                        $$('depositMassiveForm').setValues(
                                                            $$('depositMassiveForm').getCleanValues(),
                                                        );
                                                        $$('uploader4').define('label', _('Cargar archivo CSV'));
                                                        $$('uploader4').refresh();
                                                        base64CSV2 = '';
                                                    },
                                                },
                                                {
                                                    view: 'button',
                                                    type: 'form',
                                                    value: _('Guardar'),
                                                    click: function ($e) {
                                                        var values = $$('depositMassiveForm').getValues();
                                                        if ($$('depositMassiveForm').validate() && base64CSV2 != '') {
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json',
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() + 'Financial/MassiveDeposit',
                                                                    '{"CSV":"' + base64CSV2 + '"}',
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            webix.message('Error! ');
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            text = JSON.parse(text);
                                                                            if (text.HasError) {
                                                                                webix.message(
                                                                                    'Error: ' + text.AlertMessage,
                                                                                );
                                                                            } else {
                                                                                webix.message(
                                                                                    'Depósitos Masivos Creados',
                                                                                );
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                            this.getTopParentView().hide();
                                                        } else {
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Completa los campos...'),
                                                            });
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                    elementsConfig: {
                                        on: {
                                            onChange: function () {
                                                this.validate();
                                            },
                                        },
                                    },
                                },
                            })
                            .show();
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues());
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect);
                        $$('Datepicker').setValue('');
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues();
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry;
                        }
                        delete filterdata['CountrySelect2'];
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date'];
                        } else {
                            if (true) {
                                delete filterdata['Datepicker'];
                            }
                        }
                        this.app.callEvent('depositReport:filter', [filterdata]);
                        $$('b5').collapse();
                        $$('a5').scrollTo(100, 0);
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues());
                        $$('CountrySelect').setValue($$('myForm2').getCleanValues().CountrySelect);
                        $$('Datepicker').setValue('');
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues();
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry;
                        }
                        delete filterdata['CountrySelect2'];
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date'];
                        } else {
                            if (true) {
                                delete filterdata['Datepicker'];
                            }
                        }
                        this.app.callEvent('depositReport:filter', [filterdata]);
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section],
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2],
                rules: {
                    fname: webix.rules.isNotEmpty,
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [screen.width > 500 && screen.height > 500 ? accordion_section : { height: 1, width: 0 }],
            rules: {
                fname: webix.rules.isNotEmpty,
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide();
            } else {
                $$('grav2').hide();
            }
            if (profile.typeDate !== 2) {
                $$('Date').hide();
                $$('Datepicker').show();
            } else {
                if (true) {
                    $$('Date').show();
                    $$('Datepicker').hide();
                }
            }
        });
        const lang = this.app.getService('locale').getLang();
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang);
        });
    }
}

// FILE DOCUMENTED
